import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';

const artistsData = [
  {
    id: 3,
    image: '/images/Artists/Simone_Americano.jpg',
    link: 'https://open.spotify.com/intl-it/album/1m2uJbwMz02R8xFVMpUPPI?si=jNR0hZE1R2ulidf-Xcylmw',
    title: 'SIMONE BERNINI, Ep "Americano"',
    description: '',
  },
  {
    id: 2,
    image: '/images/About/HQMemphis.png',
    link: 'https://www.youtube.com/watch?v=v1UIXhBjjAw&list=RDv1UIXhBjjAw&start_radio=1',
    title: 'SIMONE BERNINI "MEMPHIS" OFFICIAL VIDEOCLIP',
    description: 'Now single "MEMPHIS"',
  },
  {
    id: 1,
    image: '/images/Artists/SimoneBernini.jpg',
    link: 'https://open.spotify.com/intl-it/artist/3uVl2X0XijpBTqBVFeAmLG',
    title: 'SIMONE BERNINI X Stihl Timbersports, Allianz Cloud',
    description: 'Live show ',
  },
]


function Simone() {
  return (
    <section className="artists">
      <Container fluid>
        <Row className="g-4 justify-content-center"> {/* Centratura e spaziatura */}
          {artistsData.map((item) => (
            <Col xs={12} sm={6} md={4} lg={3} key={item.id}>
              <div className="artists__card">
                <a href={item.link} className="artists__card-link">
                  <div className="artists__card-image">
                    <Image src={item.image} alt={item.title} fluid className="artists__card-img" />
                  </div>
                  <h3 className="artists__card-title">{item.title}</h3>
                  <p className="artists__card-description">{item.description}</p>
                </a>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}
export default Simone;
